import naja from 'naja';
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

import Confirm from './Confirm';
import {
  DATA_CANCEL_LABEL,
  DATA_CONFIRM,
  DATA_CONFIRM_LABEL,
  DATA_NO_DELETE,
  DATA_TEXT,
  DATA_TITLE,
  MODAL_ID,
  ROOT_ID,
} from './constants';

let confirmed = false;

const setConfirmed = (): void => {
  confirmed = true;
};

const isAjax = (e: HTMLElement): boolean =>
  e.getAttribute('data-ajax') !== null;

const hideModal = (): void => {
  window.$(`#${MODAL_ID}`).modal('hide');
};

const renderCallback = (event: Event, root: HTMLElement) => () => {
  const $modal = window.$(`#${MODAL_ID}`);
  event.preventDefault();
  const target = event.target as HTMLElement;
  $modal.modal('show');
  $modal.on('hidden.bs.modal', () => {
    unmountComponentAtNode(root);
    if (!confirmed) return;
    if (isAjax(target as HTMLElement)) {
      naja.uiHandler.clickElement(target as HTMLElement);
    } else {
      target.click();
    }
  });
};

const renderConfirm = (root: HTMLElement) => (event: Event) => {
  const target = event.target as HTMLElement;
  if (target.getAttribute(DATA_CONFIRM) === null) return;
  if (confirmed) {
    confirmed = false;
    return true;
  }
  const cancelLabel =
    target.getAttribute(DATA_CANCEL_LABEL) ||
    root.getAttribute(DATA_CANCEL_LABEL);
  const confirmLabel =
    target.getAttribute(DATA_CONFIRM_LABEL) ||
    root.getAttribute(DATA_CONFIRM_LABEL);
  const text = target.getAttribute(DATA_TEXT);
  const title =
    target.getAttribute(DATA_TITLE) || root.getAttribute(DATA_TITLE);
  const noDelete = target.getAttribute(DATA_NO_DELETE) != null;
  render(
    <Confirm
      cancelLabel={cancelLabel}
      confirmLabel={confirmLabel}
      noDelete={noDelete}
      hideModal={hideModal}
      setConfirmed={setConfirmed}
      text={text}
      title={title}
    />,
    root,
    renderCallback(event, root),
  );
};

const init = (): void => {
  const root = document.getElementById(ROOT_ID);
  if (root) {
    document.addEventListener('click', renderConfirm(root));
  }
};

export default { init };
